import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Search } from "lucide-react";
import { useAuth } from "@/app/providers/AuthProvider";
import { Button } from "@/shared/ui/Button";

/** 顶栏：全局搜索跳转搜索页 + 用户 */
export function Topbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  function onSearch(e: FormEvent) {
    e.preventDefault();
    const keyword = q.trim();
    if (!keyword || keyword.length > 120) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  }

  return (
    <header className="flex h-14 shrink-0 items-center justify-between gap-3 border-b border-border bg-bg-elevated px-3 sm:px-5">
      <form
        onSubmit={onSearch}
        className="flex max-w-md flex-1 items-center gap-2 rounded-[var(--radius-sm)] border border-border bg-bg-card px-2.5"
      >
        <Search className="size-3.5 shrink-0 text-fg-subtle" strokeWidth={1.75} />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="搜索影片…"
          maxLength={120}
          className="h-8 w-full bg-transparent text-[13px] text-fg outline-none placeholder:text-fg-subtle"
          aria-label="全局搜索"
        />
      </form>
      <div className="flex items-center gap-2 sm:gap-3">
        <span className="hidden max-w-[8rem] truncate text-[13px] text-fg-muted sm:inline">
          {user?.user_name ?? "未登录"}
        </span>
        <Button variant="ghost" onClick={logout} aria-label="退出登录">
          <LogOut className="size-3.5" />
          <span className="hidden sm:inline">退出</span>
        </Button>
      </div>
    </header>
  );
}
